import { render, staticRenderFns } from "./HealthAndSafety.vue?vue&type=template&id=77040932&scoped=true"
import script from "./HealthAndSafety.vue?vue&type=script&lang=js"
export * from "./HealthAndSafety.vue?vue&type=script&lang=js"
import style0 from "./HealthAndSafety.vue?vue&type=style&index=0&id=77040932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77040932",
  null
  
)

export default component.exports